module.exports = __webpack_public_path__ + "static/media/sydney.fcbf1723.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/video/sydney.mov
// module id = 985
// module chunks = 0